import React, { useEffect, useCallback, useState } from "react";
import Common_Logout from "../../common/Common_Logout";
import { useLocation } from "react-router-dom";

const InactivityTimeout = () => {
  const token = localStorage.getItem(`nic_front_authToken`);
  const loginTIme = localStorage.getItem(`frontend_loginTime`);
  const inactivityTimeout = 2 * 60 * 1000; // 20 minute
  const storageLastActivity = localStorage.getItem("lastActivity");
  const [lastActivity, setLastActivity] = useState(storageLastActivity);
  const { logout } = Common_Logout();
  const location = useLocation();

  const resetActivityTime = useCallback(() => {
    const newActivityTime = new Date().getTime();
    localStorage.setItem("lastActivity", newActivityTime);
    setLastActivity(newActivityTime);
  }, []);

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    const handleActivity = () => {
      if (token) {
        resetActivityTime();
      }
    };

    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [resetActivityTime, token]);

  // const checkLoginTime = useCallback(() => {
  //   if (token) {
  //     const currentTime = new Date().getTime();
  //     const timeDifference = currentTime - lastActivity;

  //     if (timeDifference > inactivityTimeout) {
  //       // logout();
  //     }
  //   }
  // }, [lastActivity, token, logout, inactivityTimeout]);

  // useEffect(() => {
  //   if (token) {
  //     const intervalId = setInterval(() => {
  //       checkLoginTime();
  //     }, 10 * 1000);

  //     return () => {
  //       clearInterval(intervalId);
  //     };
  //   }
  // }, [checkLoginTime, token]);

  React.useEffect(() => {
    if (loginTIme && token) {
      const loginTimestamp = parseInt(loginTIme, 10); // Convert the timestamp string to a number
      const currentTime = Date.now(); // Get the current timestamp in milliseconds

      // Calculate the difference in milliseconds
      const differenceInMilliseconds = currentTime - loginTimestamp;

      // Convert the difference to hours
      const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);
      if (differenceInHours > 2) {
        console.log("More than 2 hours have passed since login.");
        logout();
      } else {
        console.log("Less than 2 hours have passed since login.");
      }
    }
  }, [loginTIme, token, location?.pathname]);

  React.useEffect(() => {
    setLastActivity(storageLastActivity);
  }, [storageLastActivity]);

  return null;
};

export default InactivityTimeout;
